module.exports = __webpack_public_path__ + "static/media/kotopoulo-antho-alatiou.6b05885e.jpg";